import { render, staticRenderFns } from "./DefaultTextarea.vue?vue&type=template&id=8b52d9be&scoped=true"
import script from "./DefaultTextarea.vue?vue&type=script&lang=js"
export * from "./DefaultTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b52d9be",
  null
  
)

export default component.exports